import { Injectable } from "@angular/core";
import { Message } from "@shared/models/notifications/message";
import { MessageType } from "@shared/models/notifications/message-type";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";

@Injectable({
    providedIn: 'root'
})
export class WebSocketService {

    public static webSocketUrl = `${environment.gatewayApiUrl.replace("https", "wss")}/ws`;

    private socket$?: WebSocketSubject<any>;

    constructor() {
    }

    openConnection() {
        this.socket$ = webSocket(WebSocketService.webSocketUrl);
        // .subscribe() must be called to be able to send and receive messages
        this.subscribeMessages()?.subscribe();

        // on browser tab reload or close - so the web socket is properly closed
        window.addEventListener("beforeunload", () => this.closeConnection());
    }

    // Send a message to the server
    sendMessage(message: any) {
        this.socket$?.next(message);
    }

    authorizeConnection(token: string) {
        this.sendMessage({type: MessageType.AuthorizationRequest, data: token});
    }

    // Receive messages from the server
    subscribeMessages(): Observable<Message<any>> | undefined {
        return this.socket$?.asObservable();
    }

    // Close the WebSocket connection
    closeConnection() {
        this.socket$?.complete();
        this.socket$ = undefined;
    }
}